<template>
    <div class="page page-home">
    
        <Top></Top>
    
        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back()" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Avaliações</div>
                <div class="right">
                    <a style="opacity: 0;" class="link"> 
                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.7 11.717C16.6839 10.9476 17.4031 9.89041 17.7575 8.69276C18.1118 7.49511 18.0836 6.21673 17.6767 5.03589C17.2698 3.85506 16.5046 2.83063 15.4877 2.10546C14.4708 1.38028 13.253 0.990524 12.004 0.990524C10.755 0.990524 9.53719 1.38028 8.52031 2.10546C7.50342 2.83063 6.73819 3.85506 6.33131 5.03589C5.92443 6.21673 5.89619 7.49511 6.25053 8.69276C6.60487 9.89041 7.32413 10.9476 8.308 11.717C6.44917 12.4566 4.85467 13.7363 3.73027 15.391C2.60587 17.0457 2.00318 18.9994 2 21V22C2 22.2652 2.10536 22.5196 2.29289 22.7071C2.48043 22.8946 2.73478 23 3 23H21C21.2652 23 21.5196 22.8946 21.7071 22.7071C21.8946 22.5196 22 22.2652 22 22V21C21.9975 19.0003 21.3959 17.0473 20.273 15.3927C19.1501 13.7381 17.5573 12.4579 15.7 11.717ZM8 7C8 6.20887 8.2346 5.43551 8.67412 4.77772C9.11365 4.11992 9.73836 3.60723 10.4693 3.30448C11.2002 3.00173 12.0044 2.92252 12.7804 3.07686C13.5563 3.2312 14.269 3.61216 14.8284 4.17157C15.3878 4.73098 15.7688 5.44371 15.9231 6.21964C16.0775 6.99556 15.9983 7.79983 15.6955 8.53073C15.3928 9.26163 14.8801 9.88635 14.2223 10.3259C13.5645 10.7654 12.7911 11 12 11C10.9391 11 9.92172 10.5786 9.17157 9.82842C8.42143 9.07828 8 8.06086 8 7ZM4 21C4 18.8783 4.84285 16.8434 6.34315 15.3431C7.84344 13.8428 9.87827 13 12 13C14.1217 13 16.1566 13.8428 17.6569 15.3431C19.1571 16.8434 20 18.8783 20 21H4Z" fill="#000"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        
        <div class="page-content pt-70">

            <div class="container hidden-xs hidden-md">
                <h2>Avaliações</h2>
            </div>


            <div class="empty" v-if="data.itens.length == 0 && data.loaded">
                <center>
                    <img src="static/images/empty.png" style="width: 80%">
                    <p class="mt-0 pt-0">
                        <i class="las la-times"></i>
                        Nenhum resultado encontrado.
                    </p>
                </center>
            </div>

            <div class="container"> 
                <div class="row">
                    <div class="rewards-card col-50" v-for="(item, index) in data.itens" :key="item.cod" >
                        <h6 class="title mb-10">
                            <i class="las la-user"></i> 
                            <b style="font-weight: 600">Cliente:</b> {{item.contratante.nome}}
                        </h6>
                        <h6 class="title mb-10" >
                            <i class="las la-user-tie"></i>
                            <b style="font-weight: 600">Profissional:</b> {{item.prestador.nome}}
                        </h6>
                        <small>
                            <i class="las la-clock"></i>
                            {{item.datahora | formatDate}}
                        </small>
                        <div class="badge-lg">
                            <i class="las la-star"></i>
                            <strong>{{item.nota}}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Categorias',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },      
    data () {
        var self                    = this;
        return {
            "titulo":               "Categorias",
            "data":                 {
                "pages":            [],
                "itens":            []
            },
            "tab":                  "todos",
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/avaliacoes.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.$forceUpdate();
                    loading.hide();
                    resolve(response.data.result);
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        // del: function(cod) {
        //     console.log("del()", cod);
        //     var self                = this;
        //     confirm("Você tem certeza que deseja apagar esse item?", function() {
        //         var form                = JSON.parse(JSON.stringify(self.form));
        //         form.cod                = cod;
        //         self.loading.del        = true;
        //         loading.show();
                
        //         axios.delete("api/categorias.php", {params: form})
        //         .then(response => {
        //             console.log("del() response", response)
        //             self.loading.del    = false;
        //             self.get();
        //         })
        //         .catch(error => {
        //             console.log("del() error", error)
        //             loading.hide();
        //             self.loading.del    = false;
        //             alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
        //         });
        //     });
        // }        
    },
    beforeMount: function(e){
    },    
    activated: function() {
        var self = this;
        self.get();
    },
    mounted: function() {
        var self            = this;
        // self.$root.cache.categorias.  
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
    .rewards-card {
        text-align: left;
    }

    .rewards-card .badge-lg i {
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Avaliacoes.vue